import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, KeepAlive as _KeepAlive, Transition as _Transition, normalizeStyle as _normalizeStyle } from "vue";
import _imports_0 from '@/assets/img/logo_white.png';
import _imports_1 from '@/assets/img/login_logo.png';
const _hoisted_1 = {
  key: 0,
  class: "watermark"
};
const _hoisted_2 = {
  key: 0,
  class: "logo has-multi-column"
};
const _hoisted_3 = {
  class: "header-main"
};
const _hoisted_4 = {
  key: 0,
  class: "logo",
  style: {
    "padding-left": "8px",
    "margin-right": "8px"
  }
};
const _hoisted_5 = {
  class: "title"
};
const _hoisted_6 = {
  class: "header-menu",
  style: {
    "flex-grow": "1"
  }
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "el-dropdown-link"
};
const _hoisted_9 = {
  class: "layout-content"
};
const _hoisted_10 = {
  key: 0,
  class: "tag-wrap"
};
import { ElMessage, ElMessageBox } from 'element-plus';
import { useRouter, useRoute } from 'vue-router';
import defaultHeaderImg from '@/assets/img/default-header.jpg';
import { getToken, setToken } from '@/common/utils/index';
import { useLayoutStore, useLoginStore, useMessage } from '@/store';
import { SysMenuBindType } from '@/common/staticDict';
import LoginController from '@/api/system/LoginController';
import { useUpload } from '@/common/hooks/useUpload';
import { useCommon } from '@/common/hooks/useCommon';
import Sidebar from './components/Sidebar.vue';
import BreadCrumb from './components/BreadCrumb.vue';
import TagPanel from './components/TagPanel.vue';
import FormModifyPassword from './components/formModifyPassword/index.vue';
import FormModifyHeadImage from './components/formModifyHeadImage/index.vue';

import { inject, ref, computed, watch, onMounted, onBeforeUnmount } from 'vue';
const __default__ = {
  name: 'Layout'
};
export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {
    const {
      Dialog
    } = useCommon();
    const router = useRouter();
    const route = useRoute();
    const layoutStore = useLayoutStore();
    const loginStore = useLoginStore();
    const documentClientHeight = inject('documentClientHeight', ref(500));
    const projectName = process.env.VUE_APP_PROJECT_NAME;
    const {
      getUploadFileUrl
    } = useUpload();
    const userInfo = loginStore.userInfo;
    // 水印文本
    const watermarkText = computed(() => {
      if (!userInfo || !userInfo.showName) return '';
      const today = new Date();
      const dateStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, '0')}-${String(today.getDate()).padStart(2, '0')}`;
      return `${userInfo.showName} | ${dateStr}`;
    });
    // TODO 切换菜单会触发该方法？
    // 用户头像
    const headerImg = computed(() => {
      if (userInfo && userInfo.headImageUrl) {
        let temp = getUploadFileUrl(userInfo.headImageUrl, {
          filename: userInfo.headImageUrl.filename
        });
        return temp;
      } else {
        return null;
      }
    });
    // 消息数量
    const messageStore = useMessage();
    const messageCount = computed(() => {
      return messageStore.messageCount || {};
    });
    // TODO 监听当前菜单变化，跳转到目标路由
    watch(() => layoutStore.currentMenu, (newVal, oldVal) => {
      //console.log('当前页发生变化', newVal, oldVal);
      if (newVal != oldVal) {
        jumpTo(newVal);
      }
      // else {
      //   if (route.name != layoutStore.indexName) {
      //     router.replace({
      //       name: layoutStore.indexName,
      //     });
      //   }
      // }
    });
    // 路由跳转
    function jumpTo(menuItem) {
      if (menuItem != null) {
        // 路由菜单
        if (menuItem.bindType === SysMenuBindType.ROUTER && menuItem.formRouterName != null && menuItem.formRouterName !== '') {
          router.replace({
            name: menuItem.formRouterName
          });
          return;
        }
        // 外部链接
        if (menuItem.bindType === SysMenuBindType.THRID_URL && menuItem.targetUrl != null && menuItem.targetUrl !== '') {
          let token = getToken();
          let targetUrl = menuItem.targetUrl;
          if (targetUrl.indexOf('?') === -1) {
            targetUrl = targetUrl + '?';
          }
          targetUrl = targetUrl + 'token=' + token;
          window.open(targetUrl);
          return;
        }
      }
      console.warn('没有匹配到目标路由');
      if (route.name !== layoutStore.indexName) {
        router.replace({
          name: layoutStore.indexName
        });
      }
    }
    const getMainStyle = computed(() => {
      return [{
        height: documentClientHeight.value + 'px'
      }];
    });
    const getContextStyle = computed(() => {
      return [{
        height: documentClientHeight.value - (layoutStore.supportTags ? 108 : 60) + 'px'
      }];
    });
    const getRouterViewStyle = computed(() => {
      return [{
        'min-height': documentClientHeight.value - (layoutStore.supportTags ? 108 : 60) - 32 + 'px'
      }];
    });
    const handleMessage = command => {
      router.push({
        name: 'formMessage',
        query: {
          type: command
        }
      });
    };
    const handleCommand = command => {
      switch (command) {
        case 'logout':
          ElMessageBox.confirm('是否退出登录？', '', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            LoginController.logout().then(() => {
              ElMessage({
                type: 'success',
                message: '退出成功'
              });
              setToken(null);
              router.replace('/login');
            }).catch(e => {
              console.log(e);
              ElMessage({
                type: 'error',
                message: e
              });
            });
          }).catch(() => {
            console.log('取消退出');
          });
          break;
        case 'modifyPassword':
          Dialog.show('修改密码', FormModifyPassword, {
            area: '500px'
          }, {}).catch(e => {
            console.warn(e);
          });
          break;
        case 'modifyHeadImage':
          Dialog.show('修改头像', FormModifyHeadImage, {
            area: '500px'
          }, {});
          break;
        default:
          ElMessage.warning(`click on item `);
          break;
      }
    };
    onMounted(() => {
      // messageStore.startMessage();
    });
    onBeforeUnmount(() => {
      // messageStore.stopMessage();
    });
    return (_ctx, _cache) => {
      const _component_el_icon_arrow_down = _resolveComponent("el-icon-arrow-down");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_el_header = _resolveComponent("el-header");
      const _component_el_aside = _resolveComponent("el-aside");
      const _component_router_view = _resolveComponent("router-view");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      const _component_el_main = _resolveComponent("el-main");
      const _component_el_container = _resolveComponent("el-container");
      return _openBlock(), _createBlock(_component_el_container, {
        class: _normalizeClass('container-' + _ctx.defaultFormItemSize),
        style: _normalizeStyle(_unref(getMainStyle))
      }, {
        default: _withCtx(() => [_unref(userInfo) && _unref(userInfo).showName ? (_openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(20, i => {
          return _createElementVNode("div", {
            class: "watermark-item",
            key: i
          }, _toDisplayString(_unref(watermarkText)), 1);
        }), 64))])) : _createCommentVNode("", true), _createVNode(_component_el_container, {
          style: {
            "background-color": "#f5f8f9"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_el_header, {
            class: _normalizeClass(["header", _unref(layoutStore).supportColumn ? 'multi-column-header' : '']),
            style: {
              "padding": "0"
            }
          }, {
            default: _withCtx(() => [_unref(layoutStore).supportColumn ? (_openBlock(), _createElementBlock("div", _hoisted_2, [...(_cache[1] || (_cache[1] = [_createElementVNode("img", {
              src: _imports_0,
              alt: ""
            }, null, -1)]))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_3, [!_unref(layoutStore).supportColumn ? (_openBlock(), _createElementBlock("div", _hoisted_4, [...(_cache[2] || (_cache[2] = [_createElementVNode("img", {
              src: _imports_1,
              alt: ""
            }, null, -1)]))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(projectName)), 1), _createVNode(BreadCrumb, {
              class: "breadcrumb-container"
            }), _createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
              src: _unref(headerImg) ? _unref(headerImg) : _unref(defaultHeaderImg),
              class: "header-img"
            }, null, 8, _hoisted_7), _createVNode(_component_el_dropdown, {
              class: "user-dropdown",
              trigger: "click",
              onCommand: handleCommand
            }, {
              dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
                  class: "user-dropdown-item",
                  command: "modifyPassword"
                }, {
                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("修改密码", -1)]))]),
                  _: 1
                }), _createVNode(_component_el_dropdown_item, {
                  class: "user-dropdown-item",
                  command: "logout"
                }, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("退出登录", -1)]))]),
                  _: 1
                })]),
                _: 1
              })]),
              default: _withCtx(() => [_createElementVNode("span", _hoisted_8, [_createTextVNode(_toDisplayString((_unref(userInfo) || {}).showName), 1), _createVNode(_component_el_icon, {
                class: "el-icon--right"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_icon_arrow_down)]),
                _: 1
              })])]),
              _: 1
            })])])]),
            _: 1
          }, 8, ["class"]), _createVNode(_component_el_main, {
            class: "layout-main"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_aside, {
              width: _unref(layoutStore).collapsed ? _unref(layoutStore).supportColumn ? '80px' : '64px' : _unref(layoutStore).supportColumn ? '280px' : '204px',
              class: "sidebar"
            }, {
              default: _withCtx(() => [_createVNode(Sidebar, {
                style: {
                  "overflow": "hidden"
                }
              })]),
              _: 1
            }, 8, ["width"]), _createElementVNode("div", _hoisted_9, [_unref(layoutStore).supportTags ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("i", {
              class: _normalizeClass(["online-icon", _unref(layoutStore).collapsed ? 'icon-expand' : 'icon-unexpand']),
              style: {
                "font-size": "16px",
                "color": "#333",
                "cursor": "pointer"
              },
              onClick: _cache[0] || (_cache[0] = () => _unref(layoutStore).toggleCollapsed())
            }, null, 2), _createVNode(TagPanel)])) : _createCommentVNode("", true), _createVNode(_component_el_scrollbar, {
              "wrap-class": "scrollbar_dropdown__wrap",
              style: _normalizeStyle(_unref(getContextStyle))
            }, {
              default: _withCtx(() => [_createVNode(_component_router_view, {
                class: "page-box",
                style: _normalizeStyle([{
                  "overflow": "hidden",
                  "margin": "16px"
                }, _unref(getRouterViewStyle)])
              }, {
                default: _withCtx(({
                  Component
                }) => [_createVNode(_Transition, {
                  name: "el-fade-in-linear",
                  appear: true
                }, {
                  default: _withCtx(() => [(_openBlock(), _createBlock(_KeepAlive, {
                    include: _unref(layoutStore).cachePages
                  }, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))], 1032, ["include"]))]),
                  _: 2
                }, 1024)]),
                _: 1
              }, 8, ["style"])]),
              _: 1
            }, 8, ["style"])])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["class", "style"]);
    };
  }
});